// AE broker-quality coaching reference (DEV-3781). The AE reads the brokers they
// own, then each broker's file-quality scorecard from the same two gateways the
// broker-facing zone uses — but via the internal AE path that carries an explicit
// subCompanyId. Every endpoint 404s when the backend feature toggle is off; the
// slice treats that as "not available" and the page stays dark.

export const AE_BROKERS_URL = '/api/account-executives/me/brokers';

export const AE_BROKER_QUALITY_SCORECARD_UNDERWRITING_URL = '/api/command-center/quality-scorecard';

export const AE_BROKER_QUALITY_SCORECARD_LOANS_URL =
  '/api/command-center/quality-scorecard-metrics';

export const DEFAULT_AE_QUALITY_SCORECARD_WINDOW_DAYS = 90;
